import React from "react";
import logoImpala from "../../assets/img/impala-logo.png";
import {
  FaFacebook,
  FaXTwitter,
  FaLinkedin,
  FaTiktok,
  FaInstagram,
} from "react-icons/fa6";
import svg88 from "../../assets/svg/svg88.svg";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const handleClick = (path) => navigate(path);

  return (
    <div className="relative pt-[4.94rem] pb-[1.94rem] lg:px-[5.69rem] px-3 bg-surface2 font-lexendS">
      <div className="absolute top-0 left-0 right-0 h-[4px] bg-gradient-to-r from-impalaOrange to-impalaRed" />
      {/* Top Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12 pb-12 lg:pb-16">
        {/* Logo and Description */}
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <img src={logoImpala} alt="Impala Digital Payments" className="h-10 w-auto" />
          </div>
          <span className="text-ink font-[400] text-[.875rem] leading-[.5rem] max-w-md">
            Impala Digital Payments is a digital financial management platform
            <br />
            created to help businesses, contractors, event organizers,
            <br />
            and SMEs simplify how they handle money.
          </span>
        </div>

        {/* About Section */}
        <div>
          <h3 className="font-semibold text-ink mb-4 text-base">About</h3>
          <ul className="space-y-3">
            <li>
              <span
                onClick={() => handleClick("/")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Home
              </span>
            </li>
            <li>
              <span
                onClick={() => handleClick("/about")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                About Us
              </span>
            </li>
            <li>
              <span
                onClick={() => handleClick("/utility")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Utility Bill payment
              </span>
            </li>
          </ul>
        </div>

        {/* Information Section */}
        <div>
          <h3 className="font-semibold text-ink mb-4 text-base">
            Information
          </h3>
          <ul className="space-y-3">
            <li>
              <span
                onClick={() => handleClick("/contact")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Contacts
              </span>
            </li>
            <li>
              <span
                onClick={() => handleClick("/")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                FAQ
              </span>
            </li>
          </ul>
        </div>

        {/* Service Section */}
        <div>
          <h3 className="font-semibold text-ink mb-4 text-base">
            Service
          </h3>
          <ul className="space-y-3">
            <li>
              <span
                onClick={() => handleClick("/services/petty-cash")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Petty Cash Management
              </span>
            </li>
            <li>
              <span
                onClick={() => handleClick("/services/bulk-payment")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Bulk Payments
              </span>
            </li>
            <li>
              <span
                onClick={() => handleClick("/services/bill-settlement")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Bill Payments and Supplier Settlements
              </span>
            </li>
            <li>
              <span
                onClick={() => handleClick("/utility/airtime")}
                className="text-ink text-sm hover:text-impalaRed transition-colors cursor-pointer"
              >
                Airtime and Data Bundle Purchases
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-line"></div>

      {/* Contact and Social Section */}
      <div className="py-8 lg:py-10 border-t border-line">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-6">
          {/* Contacts Section */}
          <div>
            <h3 className="font-semibold text-ink mb-4 text-[1rem]">
              Contacts
            </h3>

            <div className="flex flex-col space-y-2 font-roboto">
              {/* First Row */}
              <div className="flex flex-col lg:flex-row lg:items-center lg:gap-8 text-ink text-[1rem] font-[400]">
                <span>+254 716 644 981</span>
                <span>
                  Fair Acres, Hekima Road, Building 48, Nairobi, Karen
                </span>
              </div>

              {/* Second Row */}
              <div className="flex flex-col lg:flex-row lg:items-center lg:gap-8 text-[1rem]">
                <a
                  href="mailto:operations@impaladigitalpayment.com"
                  className="text-ink hover:text-impalaRed transition-colors"
                >
                  operations@impaladigitalpayment.com
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://maps.app.goo.gl/9ue9tD6UkuS1DTTF7"
                  className="flex items-center gap-[.5rem] text-ink hover:text-impalaRed transition-colors"
                >
                  Driving directions
                  <img src={svg88} alt="svg88" className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          {/* Divider for large screens */}
          <div className="hidden lg:block w-px bg-line"></div>

          {/* Social Section */}
          <div>
            <h3 className="font-semibold text-ink mb-4 text-[1rem]">
              Social
            </h3>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/ndovupay/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-impalaRed flex items-center justify-center text-white hover:bg-impalaOrange transition-colors"
              >
                <FaFacebook size={16} />
              </a>
              <a
                href="https://x.com/NdovuPay"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-impalaRed flex items-center justify-center text-white hover:bg-impalaOrange transition-colors"
              >
                <FaXTwitter size={16} />
              </a>
              <a
                href="https://www.linkedin.com/company/ndovupay/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-impalaRed flex items-center justify-center text-white hover:bg-impalaOrange transition-colors"
              >
                <FaLinkedin size={16} />
              </a>
              <a
                href="https://www.tiktok.com/@ndovupayke"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-impalaRed flex items-center justify-center text-white hover:bg-impalaOrange transition-colors"
              >
                <FaTiktok size={16} />
              </a>
              <a
                href="https://www.instagram.com/ndovupay254/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-impalaRed flex items-center justify-center text-white hover:bg-impalaOrange transition-colors"
              >
                <FaInstagram size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-line"></div>

      {/* Bottom Section */}
      <div className="pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-6 text-sm font-roboto">
          <span className="text-ink hover:text-impalaRed transition-colors">
            Privacy policy
          </span>
          <span className="text-ink hover:text-impalaRed transition-colors">
            Terms of use
          </span>
        </div>
        <p className="text-ink text-sm">
          © {new Date().getFullYear()} Impala Digital Payments. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;
